import { Component, ReactNode } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { QuotaLayout } from "../QuotaLayout";
import { QuotaEntities } from "../QuotaEntities";
import { QuotaRouterProps } from "../QuotaRouterProps";

export interface RequestViewPageProps extends NSARouterMakerResult, QuotaRouterProps { }

export class RequestViewPage extends Component<RequestViewPageProps>
{
    override render(): ReactNode
    {
        return (
            <QuotaLayout
                {...this.props}
                action={{
                    description: "This section displays detailed information about a selected quota change request.",
                    menus: {}
                }}
                pages={{
                    entity: QuotaEntities.request(this.props),
                    view: {}
                }}
            >
                <></>
            </QuotaLayout>
        )
    }
}